<template>
    <div :key="semester.id">
        <div v-if="loading" class="text-center">
            <slot name="loading">
                <b-spinner />
            </slot>
        </div>
        <slot
            v-else-if="semester && semester.id > 0"
            name="semester-in-progress"
            :semester="semester"
        ></slot>
        <slot
            v-else-if="!authorized"
            name="not-authorized"
        >
            Not authorized
        </slot>
        <slot
            v-else
            name="no-semester"
        ></slot>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: {
        authorized() {
            return this.cached_roles["Member"];
        },
        ...mapState(["loading", "semester", "cached_roles"])
    }
}
</script>